import { v4 as uuidv4 } from 'uuid';

export const list = [
  {
    id: uuidv4(),
    label: 'Aliquam erat volutpat. Nullam libero ex, rhoncus ut lacus at.',
  },
  {
    id: uuidv4(),
    label: 'Mauris luctus magna risus, nec lobortis eros fermentum.',
  },
  {
    id: uuidv4(),
    label: 'Quisque aliquam arcu diam. Duis.',
  },
  { id: uuidv4(), label: 'Sed ut pulvinar tortor, at pellentesque ligula.' },
  { id: uuidv4(), label: 'Nullam vehicula quam justo.' },
];
